import { gql } from "@apollo/client"
import { InjectedOptions, useQuery } from "@oysterhr/core"
import { EmployerOfRecord, QueryEmployerOfRecordArgs } from "@oysterhr/schema"

const EMPLOYER_OF_RECORD_BASE_FRAGMENT = gql`
  fragment EmployerOfRecordFragment on EmployerOfRecord {
    id
    name
    notes
    entityType
    position
    cutOffMonthDay
    payrollCycleType
    colleaguesEngagedCount
    company {
      id
      name
    }
    authorizations {
      actions
    }
  }
`
const EMPLOYER_OF_RECORD_COUNTRY_FRAGMENT = gql`
  fragment EmployerOfRecordCountryFragment on EmployerOfRecordCountry {
    id
    alpha2
    concurrentHireDescription
  }
`

const EMPLOYER_OF_RECORD_DETAILS_FRAGMENT = gql`
  fragment EmployerOfRecordDetailsFragment on EmployerOfRecordDetail {
    deposit
    extraFee
    leaverFee
    legalName
    entityType
    monthlyFee
    liveStatus
    visaSupport
    legalAddress
    supportNotes
    liveIndicator
    newStarterFee
    supportEmails

    escalationNotes
    documentsForVisa
    escalationEmails
    quoteRequestNotes
    timeOffProcessLink
    oysterBenefitsLink
    offCyclePaymentFee
    visaSupportDetails
    quoteRequestEmails
    timeOffProcessNotes
    expensesProcessLink
    oysterBenefitsNotes
    eorAdvancingFundsFee
    companyContactEmails
    expensesProcessNotes
    generalEnquiriesNotes
    onboardingProcessLink
    generalEnquiriesEmails
    onboardingProcessNotes
    employmentAgreementLink
    newHiresOnboardingNotes
    newHiresOnboardingEmails
    employmentAgreementNotes
    timeOffNotificationsNotes
    timeOffMonthlyReportNotes
    visaWorkPermitProcessLink
    timeOffNotificationsEmails
    timeOffMonthlyReportEmails
    visaWorkPermitProcessNotes
    genericFinanceQuestionNotes
    payrollSpecialistRecipients
    genericFinanceQuestionEmails
    payrollSpecialistRecipientsNotes
    expensesAndPayrollNotificationsNotes
    expensesAndPayrollNotificationsEmails
    tmSalaryPayment
    pensionPayment
    taxesStatutoryPayment
    globalPayrollInvoicingCurrency
  }
`

const EMPLOYER_OF_RECORD_EXTERNAL_TOOLS_FRAGMENT = gql`
  fragment EmployerOfRecordExternalToolsFragment on ExternalTool {
    id
    url
    toolType
    description
  }
`

export const GET_EMPLOYER_OF_RECORD_BY_ID = gql`
  ${EMPLOYER_OF_RECORD_BASE_FRAGMENT}
  ${EMPLOYER_OF_RECORD_COUNTRY_FRAGMENT}
  ${EMPLOYER_OF_RECORD_DETAILS_FRAGMENT}
  ${EMPLOYER_OF_RECORD_EXTERNAL_TOOLS_FRAGMENT}
  query GetEmployerOfRecordById($employerOfRecordId: ID!) {
    employerOfRecord(employerOfRecordId: $employerOfRecordId) {
      ...EmployerOfRecordFragment
      details {
        ...EmployerOfRecordDetailsFragment
      }
      externalTools {
        collection {
          ...EmployerOfRecordExternalToolsFragment
        }
      }
      employerOfRecordCountry {
        ...EmployerOfRecordCountryFragment
      }
    }
  }
`

type EmployerOfRecordPayload = { employerOfRecord: EmployerOfRecord }

export const useEmployerOfRecord = (
  options: InjectedOptions<EmployerOfRecordPayload, QueryEmployerOfRecordArgs>,
) =>
  useQuery<EmployerOfRecordPayload, QueryEmployerOfRecordArgs>(
    GET_EMPLOYER_OF_RECORD_BY_ID,
    options,
  )
